export default class Phase
{
    public id : string | null = null;

    public number : number | null = null;

    public name : string | null = null;

    public isDeleted : boolean = false;
}